/* ==========================================================================
   Elevate Floors — Gallery: arraste por ponteiro na faixa de serviços

   O scroll nativo já funciona no touch. Isto adiciona o arraste com o mouse,
   que no desktop é o gesto que as pessoas tentam.

   O ponto delicado: cada card é um <a>. Sem a tolerância de 6px, todo arraste
   terminaria navegando para a página do último card sob o cursor.

   E o inverso também morde: capturar o ponteiro no pointerdown faz o navegador
   disparar o click no elemento que capturou, não no link sob o cursor. O card
   deixa de navegar e nada aparece no console. Por isso a captura só acontece
   depois que o gesto vira arraste de fato.

   Sem loop infinito e sem inércia, ao contrário do trilho da home: são cinco
   itens finitos e navegáveis, e um loop aqui só desorientaria.
   ========================================================================== */
(function () {
  'use strict';

  var TOL = 6;   // px de movimento a partir dos quais o clique é cancelado

  function initStrip(strip) {
    if (strip._efStripBound) return;
    strip._efStripBound = true;

    var down = false, startX = 0, startLeft = 0, moved = 0, captured = false;

    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;   // o scroll nativo já resolve
      down = true; moved = 0; captured = false;
      startX = e.clientX; startLeft = strip.scrollLeft;
      strip.classList.add('is-dragging');
      /* AQUI NÃO se captura o ponteiro. Com captura ativa o navegador dispara o
         click no elemento que capturou — o strip — e não no <a> sob o cursor,
         então clicar num card não navegava para lugar nenhum. Era um clique
         perdido silenciosamente, sem erro no console.
         A captura passou para o pointermove, e só depois da tolerância. */
    });

    strip.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));

      /* Passou de 6px: agora é arraste, não clique. Só aqui a captura importa,
         para o gesto não travar se o cursor sair do strip no meio do caminho —
         e como este clique já vai ser cancelado abaixo, capturar não custa
         nada. */
      if (!captured && moved > TOL) {
        captured = true;
        try { strip.setPointerCapture(e.pointerId); } catch (err) {}
      }

      strip.scrollLeft = startLeft - dx;
    });

    function end(e) {
      if (!down) return;
      down = false;
      strip.classList.remove('is-dragging');
      if (captured) {
        try { strip.releasePointerCapture(e.pointerId); } catch (err) {}
        captured = false;
      }
    }
    strip.addEventListener('pointerup', end);
    strip.addEventListener('pointercancel', end);

    // captura: chega antes do link. Passou da tolerância, o gesto foi arraste
    // e não clique, então a navegação não acontece.
    strip.addEventListener('click', function (e) {
      if (moved > TOL) { e.preventDefault(); e.stopPropagation(); }
      moved = 0;
    }, true);
  }

  function init() { document.querySelectorAll('[data-strip]').forEach(initStrip); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
